/**
 * Utility to load active cities configuration
 * Returns empty array if config doesn't exist (graceful fallback)
 */

let activeCitiesCache = null

export const loadActiveCities = () => {
  if (activeCitiesCache !== null) {
    return activeCitiesCache
  }

  try {
    const activeCitiesConfig = require('../config/activeCities.json')
    activeCitiesCache = activeCitiesConfig.activeCities || []
    return activeCitiesCache
  } catch (error) {
    // Config doesn't exist yet or error loading - return empty array
    // This allows the app to work before activation system is set up
    console.log('Active cities config not found, showing all cities')
    activeCitiesCache = []
    return []
  }
}

/**
 * Check if a city slug is active
 */
export const isCityActive = (citySlug) => {
  const activeCities = loadActiveCities()
  
  // If no active cities configured, show all cities (backward compatibility)
  if (activeCities.length === 0) {
    return true
  }
  
  return activeCities.includes(citySlug.toLowerCase())
}

/**
 * Filter cities array to only include active cities
 * If no active cities configured, returns all cities (backward compatibility)
 */
export const filterActiveCities = (cities) => {
  const activeCities = loadActiveCities()
  
  // If no active cities configured, return all cities
  if (activeCities.length === 0) {
    return cities
  }
  
  return cities.filter(city => isCityActive(city.Slug))
}
